import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {type IAttributeVocabulary} from '../schema';

/**
 * `getAttributeVocabulary` request params
 * (what is used to send to server)
 */

export type GetAttributeVocabularyRequestOptions = {
	id: number;
};

/**
 * `getAttributeVocabulary` request
 * (what gets sent to the server)
 */
export type GetAttributeVocabularyRequest = [number];

/**
 * `getAttributeVocabulary` response
 * (what comes back from the server)
 */
export type GetAttributeVocabularyResponse =
	SuccessResponse<GetAttributeVocabularyResult>;

/**
 * `getAttributeVocabulary` result
 * (what is utilized from the server response)
 */
export type GetAttributeVocabularyResult = IAttributeVocabulary;

export const getAttributeVocabularyEndpoint = 'getAttributeVocabulary';

/**
 * Get attribute vocabularies list
 * @param fetchParams Fetch params
 * @param signal Abort signal

 */
export const getAttributeVocabulary = async (
	{id}: GetAttributeVocabularyRequestOptions,
	signal?: AbortSignal,
): Promise<GetAttributeVocabularyResult> => {
	const client = NetxQueryClient();

	const requestParams: GetAttributeVocabularyRequest = [id];

	return client
		.post<GetAttributeVocabularyResponse>(
			getAttributeVocabularyEndpoint,
			requestParams,
			{
				signal,
			},
		)
		.then((response) => {
			const result = getResponseResults(response);
			if (result == null) throw new Error('Failed to get attribute vocabulary');
			return result;
		});
};

export default getAttributeVocabulary;
